/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type CaseStatusEnum =
  (typeof CaseStatusEnum)[keyof typeof CaseStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CaseStatusEnum = {
  Open: 1,
  Pending: 2,
  Closed: 3,
} as const;
